import React from 'react';
import PropTypes from 'prop-types';
import isArray from 'lodash/isArray';
import InnerHTML from '@Components/InnerHTML';
import { SUPPLIER_INFO_ITEMS } from '@Constants/ElementConstants';

export default class SubstanceSupplierInformation extends React.PureComponent {

  render() {
    const { substance, database, onToggle } = this.props;
    const { id } = database;
    const { supplierData } = substance;

    return (
      <div
        id='substance-supplier-information'
        className='substance-results-information typography-small'
        aria-expanded={true}>
        <div className='sub-menu'>
          <i role='button' tabIndex='0' className='sub-menu-close ss-delete' onClick={onToggle}/>
          <div className='u-els-font-size-h3'>Supplier information</div>

          {getSupplierRows(id, supplierData)}
        </div>
      </div>
    );
  }
}

function SuppierRow({ title, info }) {
  return (
    <div className='rx-substance-identification'>
      <strong className='keyword'>{title}</strong>
      <InnerHTML tag="div" html={info} />
    </div>
  );
}

function getSupplierRows(databaseId, supplierData) {
  const supplierInfo = [];
  const supplierItems = SUPPLIER_INFO_ITEMS[databaseId] || SUPPLIER_INFO_ITEMS['default'];

  supplierItems.forEach((item, index) => {
    const { name, title } = item;
    const data = supplierData[name];

    if (data) {
      supplierInfo.push(<SuppierRow key={index} title={title} info={isArray(data) ? data.join('; ') : data} />);
    }
  });

  return supplierInfo;
}

SubstanceSupplierInformation.propTypes = {
  database: PropTypes.object.isRequired,
  substance: PropTypes.object.isRequired,
  onToggle: PropTypes.func.isRequired,
};
